import SearchComponent from "../SearchComponent";
import {
  humanCalculators_Fr,
  healthCalculators_Fr,
  financialCalculators_Fr,
  womenCalculators_Fr,
  studyCalculators_Fr,
  mathCalculators_Fr,
  physicsCalculators_Fr,
  chemistryCalculators_Fr,
  otherCalculators_Fr,
  foodCalculators_Fr,
  islamicCalculators_Fr,
} from "../Fr/ConstantsFr";
import { Icons } from "../Icons";

const cardData = [
  {
    cardNumber: 1,
    cardTitle: "Calculatrices de temps et de date",
    cardIcon: <Icons.AccessTime />,
    cardItems: humanCalculators_Fr,
    calculatorUrl: "/fr/human-calculators/",
  },
  {
    cardNumber: 2,
    cardTitle: "Calculatrices de santé et de fitness",
    cardIcon: <Icons.Favorite />,
    cardItems: healthCalculators_Fr,
    calculatorUrl: "/fr/health-calculators/",
  },
  {
    cardNumber: 3,
    cardTitle: "Calculatrices pour femmes",
    cardIcon: <Icons.Female />,
    cardItems: womenCalculators_Fr,
    calculatorUrl: "/fr/women-calculators/",
  },
  {
    cardNumber: 4,
    cardTitle: "Calculatrices mathématiques",
    cardIcon: <Icons.Calculate />,
    cardItems: mathCalculators_Fr,
    calculatorUrl: "/fr/math-calculators/",
  },
  {
    cardNumber: 5,
    cardTitle: "Calculatrices d'études et GPA",
    cardIcon: <Icons.School />,
    cardItems: studyCalculators_Fr,
    calculatorUrl: "/fr/study-calculators/",
  },
  {
    cardNumber: 6,
    cardTitle: "Calculatrices de physique",
    cardIcon: <Icons.Science />,
    cardItems: physicsCalculators_Fr,
    calculatorUrl: "/fr/physics-calculators/",
  },
  {
    cardNumber: 7,
    cardTitle: "Calculatrices de chimie",
    cardIcon: <Icons.Biotech />,
    cardItems: chemistryCalculators_Fr,
    calculatorUrl: "/fr/chemistry-calculators/",
  },
  {
    cardNumber: 8,
    cardTitle: "Calculatrices financières",
    cardIcon: <Icons.AttachMoney />,
    cardItems: financialCalculators_Fr,
    calculatorUrl: "/fr/financial-calculators/",
  },
  {
    cardNumber: 9,
    cardTitle: "Calculatrices alimentaires",
    cardIcon: <Icons.Restaurant />,
    cardItems: foodCalculators_Fr,
    calculatorUrl: "/fr/food-calculators/",
  },
  {
    cardNumber: 10,
    cardTitle: "Calculatrices islamiques (Zakat)",
    cardIcon: <Icons.VolunteerActivism />,
    cardItems: islamicCalculators_Fr,
    calculatorUrl: "/fr/islamic-calculators/",
  },
  {
    cardNumber: 11,
    cardTitle: "Autres calculatrices",
    cardIcon: <Icons.MoreHoriz />,
    cardItems: otherCalculators_Fr,
    calculatorUrl: "/fr/other-calculators/",
  },
];

function CardGroups() {
  return (
    <div className="ltr-container">
      <SearchComponent isEnglish={false} isFrench={true} />
      <br />
      <div
        className="row row-cols-1 row-cols-md-4 g-4"
        style={{ position: "relative", zIndex: "1" }}
      >
        {cardData.map((card, index) => (
          <div className="col" xs key={index} style={{ paddingBottom: "10px" }}>
            <div className="card">
              <div className="card-body">
                <div className="p-1 bg-success text-white">
                  <a
                    href={card.calculatorUrl}
                    style={{
                      fontSize: "16px",
                      color: "white",
                      padding: "10px",
                      display: "block",
                    }}
                    aria-label={card.cardTitle}
                  >
                    <div className="card-title">
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {card.cardIcon}
                      </div>
                      <h2
                        style={{
                          fontSize: "16px",
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ marginLeft: "10px" }}>
                          {card.cardTitle}
                        </span>
                      </h2>
                    </div>
                  </a>
                </div>
                <hr />
                <div className="card-text">
                  {card.cardItems.slice(0, 7).map((item, itemIndex) => (
                    <a
                      key={itemIndex}
                      href={item.link}
                      className="item-link"
                    >
                      <span style={{ fontSize: "14px" }}>{item.name}</span>{" "}
                      <br />
                    </a>
                  ))}
                </div>
              </div>
              <div className="card-footer" style={{ textAlign: "center" }}>
                <div style={{ paddingBottom: "10px" }}>
                  <a
                    className="btn btn-outline-success"
                    style={{ width: "90%" }}
                    href={card.calculatorUrl}
                  >
                    Voir plus
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CardGroups;
